import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RouteDetailViewModel } from '../../../viewModels/route-detail-viewmodel';
import { SelectedRouteViewModel } from '../../../viewModels/selectedRoute.viewmodel';
import * as _ from 'lodash';

@Component({
  selector: 'app-route-selector',
  templateUrl: './route-selector.component.html',
  styleUrls: ['./route-selector.component.scss']
})
export class RouteSelectorComponent implements OnInit {
  @Input() public routes: SelectedRouteViewModel[];
  @Output() public onClose: EventEmitter<boolean>;

  private availableRoutes: SelectedRouteViewModel[];

  private readonly maxItemsAllowed = 5;
  public maxPossibleItems: number;
  public itemsSelected: number;

  constructor() {
    this.onClose = new EventEmitter<boolean>();
    this.availableRoutes = [];
  }

  ngOnInit(): void {
    this.availableRoutes = _.cloneDeep(this.routes);
    this.maxPossibleItems = (this.availableRoutes.length > this.maxItemsAllowed) ? this.maxItemsAllowed : this.routes.length;
    this.setItemsSelected();
  }

  setItemsSelected(): void {
    this.itemsSelected = _.filter(this.availableRoutes, (route: SelectedRouteViewModel) => route.selected).length;
  }

  isDisabled(route: SelectedRouteViewModel): boolean {
    return this.itemsSelected >= this.maxItemsAllowed && !route.selected;
  }

  noItemsSelected(): boolean {
    return this.itemsSelected === 0;
  }

  hasAvailableRoutes(): boolean {
    return this.availableRoutes.length > 0;
  }

  apply(): void {
    _.each(this.availableRoutes, (routeSelection: SelectedRouteViewModel) => {
      let route = _.find(this.routes, r => r.routeId === routeSelection.routeId);
      if (route) {
        route.selected = routeSelection.selected;
      }
    });

    this.onClose.emit(true);
  }

  cancel() {
    this.onClose.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/route-selector/route-selector/route-selector.component.ts